<template>
	<div>
		<v-text-field
			:label="column.name"
			dense
			outlined
			:rules="[]"
			class="mt-4"
			v-model="valueByColumn"
			v-if="
				column.data_type == 'string' || column.data_type == 'url' || column.data_type == 'feature'
			"
		/>
		<v-textarea
			:label="column.name"
			dense
			outlined
			:rules="[]"
			class="mt-4"
			v-model="valueByColumn"
			v-if="column.data_type == 'text'"
		/>
		<v-select
			:label="column.name"
			:items="column.requirement_column_options"
			item-text="text"
			item-value="text"
			hint="選択してください"
			no-data-text="選択肢ががありません"
			class="mt-4"
			outlined
			dense
			v-if="column.data_type == 'option'"
			v-model="valueByColumn"
		/>
		<v-text-field
			:label="column.name"
			type="date"
			dense
			outlined
			:rules="[]"
			class="mt-4"
			v-model="valueByColumn"
			v-else-if="column.data_type == 'date'"
		/>
		<div class="mt-4" v-else-if="column.data_type == 'boolean'">
			<v-row no-gutters class="mt-1 checkbox-wrapper">
				<v-checkbox v-model="valueByColumn" :label="column.name" :rules="[]" class="mr-2" dense />
			</v-row>
		</div>
		<v-text-field
			:label="column.name"
			type="number"
			dense
			outlined
			:rules="integerRules"
			class="mt-4"
			v-model="valueByColumn"
			v-else-if="column.data_type == 'integer'"
		/>
		<v-text-field
			:label="column.name"
			type="number"
			dense
			outlined
			step="0.01"
			:rules="floatRules"
			class="mt-4"
			v-model="valueByColumn"
			v-else-if="column.data_type == 'float'"
		/>
		<DragUpload
			ref="upload"
			v-else-if="column.data_type == 'file'"
			:label="column.name"
			@fileShare="fileShare($event)"
		/>
		<AssociationSelectDialog
			v-else-if="column.data_type == 'target'"
			:label="column.name"
			:value.sync="value"
			:association_value.sync="value.name"
			:type="'value_target_type'"
			:id="'value_target_id'"
			:associationName="column.association_name"
		/>
		<SynchronizationForm
			v-if="column.data_type == 'synchronization' && column.data_synchronization"
			:column="column"
			:value.sync="value.synchronized_data"
			:display_value.sync="value.display_value"
		/>
	</div>
</template>

<script>
import common from "../../../helper/common"

import DragUpload from "../../shared/DragUpload.vue"
import AssociationSelectDialog from "../../shared/AssociationSelectDialog.vue"
import SynchronizationForm from "../../shared/SynchronizationForm.vue"

export default {
	props: {
		column: {
			type: Object,
			required: true,
		},
		value_data: {
			type: Object,
			required: true,
		},
	},
	components: {
		DragUpload,
		AssociationSelectDialog,
		SynchronizationForm,
	},
	data() {
		return {
			common: common,
			integerRules: [(v) => (v >= -99999 && v <= 99999) || "値の範囲は-99999〜99999です"],
			floatRules: [(v) => (v >= -999 && v <= 999) || "値の範囲は-999=〜999です"],
		}
	},
	methods: {
		fileShare(files, _) {
			this.value.value_file = files
		},
	},
	computed: {
		valueByColumn: {
			get() {
				if (this.column.data_type != "target") {
					return this.value[`value_${this.column.data_type}`]
				}
			},
			set(newVal) {
				if (this.column.data_type != "target") {
					return (this.value[`value_${this.column.data_type}`] = newVal)
				}
			},
		},
		value: {
			get() {
				return this.value_data
			},
			set(newVal) {
				return this.$emit("update:value_data", newVal)
			},
		},
	},
}
</script>